(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.add('always-fixed');
      }

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-prod-backup"]) return;
  try {
    
  /* Product image/video modal */
  class ProductModal extends ModalDialog {
    constructor() { super(); }
    hide() { super.hide(); window.pauseAllMedia(); }
    show(opener) { super.show(opener); this.showActiveMedia(); }
    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`
      ).forEach((el) => el.classList.remove('active'));
      const activeMedia = this.querySelector(
        `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`
      );
      if (activeMedia) {
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
        if (activeMedia.nodeName === 'DEFERRED-MEDIA') {
          const tpl = activeMedia.querySelector('template');
          if (tpl && tpl.content && tpl.content.querySelector('.js-youtube')) {
            activeMedia.loadContent();
          }
        }
      }
    }
  }
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', ProductModal);
  }

  /* On-demand product recommendations */
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(r => r.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recs = html.querySelector('product-recommendations--single') || html.querySelector('product-recommendations');
            if (recs && recs.innerHTML.trim().length) this.innerHTML = recs.innerHTML;
          })
          .catch(console.error);
      };
      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }
  if (!customElements.get('product-recommendations--single')) {
    customElements.define('product-recommendations--single', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  /* Modal: easy close + desktop scroll fixes */
  class ProductModal extends ModalDialog {
    constructor() { super(); }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
      this._attachModalHandlers();
    }

    hide() {
      super.hide();
      window.pauseAllMedia?.();
      this._detachModalHandlers();
    }

    _attachModalHandlers() {
      document.documentElement.classList.add('pdp-modal-open');

      this._dialog  = this.querySelector('.product-media-modal__dialog');
      this._content = this.querySelector('.product-media-modal__content');

      /* ESC */
      this._escHandler = (e) => { if (e.key === 'Escape') this.hide(); };
      document.addEventListener('keydown', this._escHandler);

      /* Outside click (capture) */
      this._outsidePointerDown = (e) => {
        const tgt = e.composedPath ? e.composedPath()[0] : e.target;
        if (this._content && !this._content.contains(tgt)) {
          e.preventDefault();
          this.hide();
        }
      };
      this.addEventListener('pointerdown', this._outsidePointerDown, true);

      /* Swipe down to close (mobile) */
      let startY = null, startX = null;
      this._touchStart = (e) => {
        if (!e.touches || !e.touches.length) return;
        startY = e.touches[0].clientY;
        startX = e.touches[0].clientX;
      };
      this._touchEnd = (e) => {
        if (startY == null) return;
        const dy = e.changedTouches[0].clientY - startY;
        const dx = e.changedTouches[0].clientX - startX;
        if (dy > 80 && Math.abs(dx) < 60) this.hide();
        startY = startX = null;
      };
      const swipeTarget = this._dialog || this;
      swipeTarget.addEventListener('touchstart', this._touchStart, { passive: true });
      swipeTarget.addEventListener('touchend',   this._touchEnd);

      /* Wheel trap */
      this._wheelTrap = (e) => { e.stopPropagation(); };
      this._dialog?.addEventListener('wheel', this._wheelTrap, { passive: false, capture: true });
    }

    _detachModalHandlers() {
      document.documentElement.classList.remove('pdp-modal-open');

      document.removeEventListener('keydown', this._escHandler);
      this._escHandler = null;

      this.removeEventListener('pointerdown', this._outsidePointerDown, true);
      this._outsidePointerDown = null;

      const swipeTarget = this._dialog || this;
      swipeTarget?.removeEventListener('touchstart', this._touchStart);
      swipeTarget?.removeEventListener('touchend',   this._touchEnd);
      this._touchStart = this._touchEnd = null;

      this._dialog?.removeEventListener('wheel', this._wheelTrap, true);
      this._wheelTrap = null;

      this._dialog = this._content = null;
    }

    showActiveMedia() {
      /* Deactivate others */
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`
      ).forEach((el) => el.classList.remove('active'));

      /* Activate current + scroll into view */
      const activeMedia = this.querySelector(
        `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`
      );
      if (activeMedia) {
        activeMedia.classList.add('active');
        try { activeMedia.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
        catch(e) { activeMedia.scrollIntoView(); }
        if (activeMedia.nodeName === 'DEFERRED-MEDIA') {
          const tpl = activeMedia.querySelector('template');
          if (tpl && tpl.content && tpl.content.querySelector('.js-youtube')) {
            activeMedia.loadContent();
          }
        }
      }
    }
  }
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', ProductModal);
  }

  /* Mobile: sync main image on variant change */
  (() => {
    const section = document.getElementById('MainProduct-{{ section.id }}');
    if (!section) return;
    const mobile = section.querySelector('#MobileGallery-{{ section.id }}');
    if (!mobile) return;

    document.addEventListener('variant:change', (evt) => {
      const v = evt.detail && evt.detail.variant;
      const fm = v && v.featured_media;
      if (!fm) return;
      const mainImg = mobile.querySelector('[data-mobile-main-img]');
      const mainBtn = mobile.querySelector('[data-mobile-main-btn]');
      if (!mainImg || !mainBtn) return;

      const thumbBtn = mobile.querySelector(`.mobile-gallery__thumb-btn[data-media-id="${fm.id}"]`);
      const imgFromThumb = thumbBtn && thumbBtn.querySelector('img');
      const full = thumbBtn && thumbBtn.getAttribute('data-full');

      if (full) { mainImg.src = full; mainImg.removeAttribute('srcset'); }
      else if (imgFromThumb) { mainImg.src = imgFromThumb.currentSrc || imgFromThumb.src; mainImg.removeAttribute('srcset'); }
      mainBtn.setAttribute('data-media-id', String(fm.id));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);
	

  } catch(e) { console.error(e); }
})();
})();
